export {default as TaskDetails} from './TaskDetails.connect';
